import cn from 'classnames';
import ContentfulParser from 'components/BlogCommon/Article/ContentfulParser';
import Illustration from 'UI/components/Illustration';
import LinkWrapper from 'UI/components/LinkWrapper';
import Typography from 'UI/components/Typography';
import { TYPOGRAPHY_SIZE, TYPOGRAPHY_TAGS } from 'UI/components/Typography/utils/useTypography';
import Overlay from 'UI/containers/Overlay';
import styles from './OverlapCard.module.scss';

const hasTextContent = (text) => {
  if (!text) {
    return false;
  }

  if (typeof text === 'string') {
    return Boolean(text.trim());
  }

  return Boolean(text?.content?.length);
};

const OverlapCard = ({
  className,
  image,
  title,
  text,
  description,
  url,
}) => {
  if (!image?.url) {
    return null;
  }

  const hasHoverContent = Boolean(title || description || hasTextContent(text));
  const Wrapper = url ? LinkWrapper : 'div';

  return (
    <Wrapper
      {...(url && { path: url })}
      className={cn(styles.overlapCard, className)}
    >
      <Illustration
        className={styles.image}
        src={image.url}
        alt={image.alt || title || ''}
        transparent
      />

      {hasHoverContent && (
        <Overlay className={styles.overlay}>
          {title && (
            <Typography
              variant={TYPOGRAPHY_TAGS.h3}
              size={TYPOGRAPHY_SIZE.headline20}
              isBold
            >
              {title}
            </Typography>
          )}

          {(hasTextContent(text) || description) && (
            text
              ? <ContentfulParser document={text} />
              : <p>{description}</p>
          )}
        </Overlay>
      )}

      {url && (
        <span className={styles.badge}>
          <svg
            width={16}
            height={16}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2.5}
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M7 17 17 7M9 7h8v8" />
          </svg>
        </span>
      )}
    </Wrapper>
  );
};

export default OverlapCard;
